import { Select } from '@/components/ui/select'
import { TIMEZONES_BR, isCuratedTimezone } from '@/lib/timezones-br'

export interface TimezoneSelectProps {
  id?: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

/**
 * Story 3.16.1 — TZ dropdown agrupado (Brasil primeiro, Outros depois).
 *
 * Composto sobre `<Select>` atom (REUSE — IDS-compliant) usando native
 * `<optgroup>` para acessibilidade keyboard + type-ahead nativo do browser.
 *
 * Quando `value` está fora da lista curated (ex: legacy data com TZ
 * exótico), renderiza opção extra "(fora da lista)" para preservar o
 * valor — admin pode mantê-lo OR escolher um da lista.
 */
export function TimezoneSelect({
  id,
  value,
  onChange,
  disabled = false,
}: TimezoneSelectProps): React.ReactElement {
  const brTimezones = TIMEZONES_BR.filter((tz) => tz.group === 'br')
  const otherTimezones = TIMEZONES_BR.filter((tz) => tz.group === 'other')
  const showLegacyOption = value !== '' && !isCuratedTimezone(value)

  return (
    <Select
      id={id}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      {value === '' && (
        <option value="" disabled>
          Selecione um timezone…
        </option>
      )}
      <optgroup label="Brasil">
        {brTimezones.map((tz) => (
          <option key={tz.value} value={tz.value}>
            {tz.label}
          </option>
        ))}
      </optgroup>
      <optgroup label="Outros">
        {otherTimezones.map((tz) => (
          <option key={tz.value} value={tz.value}>
            {tz.label}
          </option>
        ))}
      </optgroup>
      {showLegacyOption && (
        <optgroup label="Valor atual (fora da lista)">
          <option value={value}>{value}</option>
        </optgroup>
      )}
    </Select>
  )
}
